<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4" style="max-width:545px">
        <h3>Alkoholrapport</h3>

        <div v-if="!loading">
            <div v-if="hasMultiLocations()" class="mt-4">
              <span class="ingredient-title">Velg avdeling</span>
              <select class="form-select" v-model="locationId" @change="onLocationChange()">
                <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
              </select>
            </div>

            <SelectDate ref="selectDateFrom" label="Velg fra og med dato" :selectedDate="fromDateString"/>
            <SelectDate ref="selectDateTo" label="Velg til og med dato" :selectedDate="toDateString"/>

            <button type="button" class="bo_btn mt-3" :class="zReports.length == 0 ? 'mb-5' : 'mb-0'" @click="showAlcoholReport"> Vis alkoholrapport </button>

            <div v-if="zReports.length == 0 && resultFetched" class="xz-report mb-5">
              <p class="no-report-found">Ingen alkoholsalg.</p>
            </div>

            <ShowAlcoholReport v-if="zReports.length > 0"
                                :zReports="zReports"
                                :vat="vat"
                                :company="company"
                                :location="getLocation()"
                                :fromDate="fromDate"
                                :toDate="toDate" />

        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SelectDate from "@/components/other/SelectDate";
  import ShowAlcoholReport from "@/components/report/alcohol/ShowAlcoholReport";
  import ReportService from "@/services/report/ReportService";
  import LocationUtil from "@/util/LocationUtil";
  import MerchantUtil from "@/util/MerchantUtil";
  import moment from "moment";

  export default {
    components: {LoadingSpinner, SelectDate, ShowAlcoholReport},
    data() {
      return {
        loading: true,

        locationId: '',
        locations: [],
        merchant: '',
        company: {},
        vat: {},
        fromDate: new Date(),
        toDate: new Date(),
        fromDateString: moment().format('YYYY-MM-DD'),
        toDateString: moment().format('YYYY-MM-DD'),
        zReports: [],
        resultFetched: false
      };
    },
    mounted() {
      ReportService.getDataForReportGui().then(
          (response) => {
            let dataForGui = response.data;
            //console.log("dataForGui: " +  JSON.stringify(dataForGui));
            this.merchant = dataForGui.merchant;
            this.company = dataForGui.company;
            this.locations = dataForGui.locations;
            this.vat = dataForGui.vat;

            this.locationId = this.locations.length ? this.locations[0].id : '';
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      onLocationChange() {
        // No async work here — the report is only fetched on "Vis alkoholrapport".
        // Just clear any previously shown report; don't flip loading (nothing resets it).
        this.zReports = []; //reset it
        this.resultFetched = false;
      },
      useFunctionality(){
        return MerchantUtil.useFunctionality();
      },
      getLocation(){
        return LocationUtil.getLocation(this.locationId);
      },
      showAlcoholReport() {
        this.loading = true;
        this.fromDateString = this.$refs.selectDateFrom.getSelectedDate();
        this.toDateString = this.$refs.selectDateTo.getSelectedDate();
        this.fromDate = moment(this.fromDateString, 'YYYY-MM-DD').toDate();
        this.toDate = moment(this.toDateString, 'YYYY-MM-DD').toDate();

        ReportService.getAlcoholReport(this.locationId, this.fromDateString, this.toDateString).then(
            (response) => {
              if(response.data){
                //console.log(response.data.result);
                  this.zReports =response.data;
              } else {
                  this.zReports = [];
              }

              this.loading = false;
              this.resultFetched = true;
            },
            (error) => {
              console.log(error);
            }
        );
      }
    }
  };
</script>